import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react'
import { DecisionTablePopupPropsTypes } from './PopupTypes'
import { CloseIcon, SearchIcon } from '../iconSet/IconSet'
import DataTable from 'react-data-table-component'
import { SensorsTypes } from '../../Data'
import { customStyles } from './CustomDataTableStyles'
import TableNoData from '../tablePartComp/TableNoData'
import TableTitle from '../tablePartComp/TableTitle'
import DecisionDataTable from './DecisionDataTable'
import { valid } from 'semver'
import AlertDialog from './AlertDialog'

/* const sensorColumns = [
    {name: 'ID', selector: (row: SensorsTypes) => row.id},
    {name: 'Sensor', selector: (row: SensorsTypes) => row.sensor},
    {name: 'Threshold Level', selector: (row: SensorsTypes) => row.criteria}
] */

const DecisionTablePopup = (props: DecisionTablePopupPropsTypes) => {

	const BASE_URL = process.env.REACT_APP_BASE_URL
    const [selectedRows, setSelectedRows] = useState<SensorsTypes[]>([])
    const selectedRowRef = useRef<SensorsTypes[]>([])

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

    const showAlertDialog = (title: string, description: string, callback?: () => void) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertCallback(() => callback); // wrap in function to preserve reference
    setAlertDialogState(true);
    };

    const validInputRef = useRef<boolean>(true);

    const [filterText, setFilterText] = useState("")
    const [filteredData, setFilteredData] = useState<SensorsTypes[]>([])
    
    const [error, setError] = React.useState(null)
    const [isLoaded, setIsLoaded] = React.useState(false)
    /* const [sensors, setSensors] = React.useState<SensorsTypes[]>([
        { id: 1, sensor: "Rathnapura River Sensor", criteria: "< 100.00", hazardtype: "FLW", interval: 10 },
        { id: 2, sensor: "Pugoda River Sensor", criteria: "< 105.00", hazardtype: "FLW", interval: 10 },
        { id: 3, sensor: "Kuruvita River Sensor", criteria: "< 88.00", hazardtype: "FLW", interval: 10 },
        { id: 4, sensor: "Kalawana River Sensor", criteria: "< 55.00", hazardtype: "FLW", interval: 10 },
        { id: 5, sensor: "Kahawaththa River Sensor", criteria: "< 200.00", hazardtype: "FLW", interval: 10 },
        { id: 6, sensor: "Elapatha River Sensor", criteria: "< 70.00", hazardtype: "FLW", interval: 10 },
        { id: 7, sensor: "Rathnapura Landslide Sensor", criteria: "< 700.00", hazardtype: "LSW", interval: 10 },
        { id: 8, sensor: "Elapatha Landslide Sensor", criteria: "< 40.00", hazardtype: "LSW", interval: 10 },
        { id: 9, sensor: "Kuruvita Landslide Sensor", criteria: "< 600.00", hazardtype: "LSW", interval: 10 },
        { id: 10, sensor: "Mapitigama Landslide Sensor", criteria: "< 110.00", hazardtype: "LSW", interval: 10 },
        { id: 11, sensor: "Pugoda Landslide Sensor", criteria: "< 70.00", hazardtype: "LSW", interval: 10 }
    ]) */

    const [sensors, setSensors] = React.useState<SensorsTypes[]>([]);

    const handleSelectRow = ({ selectedRows }: { selectedRows: SensorsTypes[] }) => {
        //setSelectedRows(selectedRows)
        selectedRowRef.current = selectedRows
    }

    useEffect(() => {
        fetch(BASE_URL + "/iot/api/v1/sensors")
            .then((res) => {
            if (!res.ok) {
                throw new Error("Network response was not ok " + res.statusText);
            }
            return res.json();
            })
            .then((result: SensorsTypes[]) => {
            setSensors(result);
            setFilteredData(result);
            setIsLoaded(true);
            })
            .catch((error) => {
            console.error("Error fetching sensors:", error);
            setError(error);
            setIsLoaded(true);
            });
        }, []);

    // Handle search
    const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
        const text = event.target.value
        setFilterText(text)
        
        const filtered = sensors.filter((item) =>
            Object.values(item).some((value) => {
                if (value !== null && value !== undefined) {
                    return value.toString().toLowerCase().includes(text.toLowerCase())
                }
                return false
            })
        );
        setFilteredData(filtered)
    } 

    /* useEffect(() => {
        setTimeout(() => {
            fetch("http://localhost:8000/sensors")
                .then((res) => res.json())
                .then(
                (result: SensorsTypes[]) => {
                    setIsLoaded(true);
                    setSensors(result);
                    const temp: SensorsTypes[] = result.filter(obj => obj.hazardtype === props.hazardType)
                    setFilteredData(temp)
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
                );
            }, 1000);
    }, []); */

    const handleAddClick = useCallback(() => {
        if(validInputRef.current && validInputRef.current === true) {
            if( props.function){
                props.function(selectedRows)
            }
            props.setWindowState(false)
        } else {
            showAlertDialog("Invalid Format", "Invalid criteria format. Use '> number' or '< number'");
        }
        
        
    }, [selectedRows, validInputRef])
    useEffect(() => {
        console.log("Selected: ", selectedRows)
    }, [selectedRows])

    return (
        <div className={`workflow-popup`}>
            <div className={`workflow-popup-wrapper`}>
                <div className={`title`}>
                    <span>{props.title}</span>
                    <CloseIcon width='1.2rem' color='var(--color-main-red)' onClick={(e) => props.setWindowState(false)}/>
                </div>
                <div className={`data-wrapper`}>
                    <DecisionDataTable data={sensors} setSelectedRows={setSelectedRows} valid={validInputRef}/>
                    {/* <div className={`search-box-wrapper`}>
                        <div className={`input-wrapper`}>
                            <i><SearchIcon color='var(--color-main-white)' width='1.2rem' /></i>
                            <input type="text" placeholder='Search' onChange={(e) => handleSearch(e)}/>
                        </div>
                    </div>
                    <div className={`table-box`}>
                        <DataTable title={<TableTitle title="select decision"/>} columns={sensorColumns} data={filteredData} customStyles={customStyles} onSelectedRowsChange={handleSelectRow} pagination selectableRows highlightOnHover noDataComponent={<TableNoData />}/>
                    </div> */}
                    <div className={`button-wrapper`} style={{gridArea: 'buttons'}}>
                        <div className={`left-side`}></div>
                        <div className={`right-side`}>
                            <button className={`button-normal`} onClick={handleAddClick}>add</button>
                        </div>
                    </div>
                </div>
            </div>
            {alertDialogState && (
                <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertCallback}
                />
            )}
        </div>
    )
}

export default DecisionTablePopup